import { render, staticRenderFns } from "./trocar-ativo.vue?vue&type=template&id=2d2dc380&"
import script from "./trocar-ativo.vue?vue&type=script&lang=js&"
export * from "./trocar-ativo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d2dc380')) {
      api.createRecord('2d2dc380', component.options)
    } else {
      api.reload('2d2dc380', component.options)
    }
    module.hot.accept("./trocar-ativo.vue?vue&type=template&id=2d2dc380&", function () {
      api.rerender('2d2dc380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/trocar-ativo.vue"
export default component.exports